import React, { useState, useEffect, useCallback } from "react";
import { PageHeader } from "../../features/shared";
import { Tab, Tabs } from "react-bootstrap";
import { getAllSH3Emails } from "../../services/DRM/getSH3Email";
import { getAllSH3EmailsMeetDetails } from "../../services/DRM/getMeetingDetailsByEmail";
import { Loader } from "../../features/shared";
import { useSelector } from "react-redux";
import { addMeetingApprovalApi } from "../../services/DRM/addMeetingApproval";
import "./DRMDetails.css";
import styles from "./DrmMeetingApproval.module.css";
import _ from "lodash";
//import { LuCircleArrowRight } from "react-icons/lu";
import { SlArrowRightCircle } from "react-icons/sl";
import { useNavigate } from "react-router-dom";
import ModalPopup from "../Common/ModalPopup";
import { Message } from "../../features/shared";
import { getAllSH5Emails } from "../../services/DRM/getSH5Email";
import { getAllTMMEmails } from "../../services/DRM/getTMMEmail";

const DRMMeetingApproval = () => {
  const [loading, setLoading] = useState(false);
  const [meetingDetails, setMeetingDetails] = useState([]);
  const [remarksError, setRemarksError] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [selectedMeetingId, setSelectedMeetingId] = useState(null);
  const userRole = useSelector((state) =>
    state?.userType?.type !== "Other"
      ? state?.userType?.type
      : state?.userDetails?.details?.Title
  );

  const userEmailid = useSelector(
    (state) => state?.userDetails?.details?.Email
  );

  const divisionCode = useSelector(
    (state) => state?.userDetails?.details?.Division
  );

  const salesGroupCode = useSelector(
    (state) =>
       userRole === "TMM" ? state?.SelectedSalesGroupCode?.SalesGroupCode : state?.userDetails?.details?.Sales_Group_Code__c !== null
        ? state?.userDetails?.details?.Sales_Group_Code__c
        : state?.SelectedSalesGroupCode?.SalesGroupCode
  );

  // Determine which tabs to show based on user role
  const getAvailableTabs = () => {
    if (userRole === "SH5" || userRole === "SH6") {
      return []; // ZSM sees BM data without tabs
    } else if (userRole === "TMM") {
      return ["BM", "ZSM"];
    } else if (userRole === "SH7") {
      return ["BM", "ZSM", "TMM"];
    }
    return ["BM", "ZSM", "TMM"]; // Default
  };

  const tabs = getAvailableTabs();
  const [tab, setTab] = useState(tabs.length > 0 ? tabs[0] : "BM");

  const fetchEmailsAndMeetings = useCallback(async () => {
    setLoading(true);

    try {
      // ───────────────────────────────────────────────
      // 1️⃣ CALL EMAIL APIs CONDITIONALLY BASED ON USER ROLE
      // ───────────────────────────────────────────────
      const apiCallsToMake = [];

      // SH5 (ZSM) → Only needs SH3 (BM)
      if (userRole === "SH5") {
        apiCallsToMake.push(getAllSH3Emails({ userEmailid, userRole }));
      }
      // SH6 (ZSM) → Needs SH3 (BM) and SH5 (ZSM)
      else if (userRole === "SH6") {
        apiCallsToMake.push(getAllSH3Emails({ userEmailid, userRole }));
        apiCallsToMake.push(getAllSH5Emails({ userEmailid, userRole }));
      }
      // SH7 (NSM) → Needs SH3, SH5, and SH6 (TMM)
      else if (userRole === "SH7") {
        apiCallsToMake.push(getAllSH3Emails({ userEmailid, userRole }));
        apiCallsToMake.push(getAllSH5Emails({ userEmailid, userRole }));
        apiCallsToMake.push(getAllTMMEmails({ userEmailid, userRole }));
      }
      // TMM → Needs SH3 and SH5, fetched by division + salesgroup from DW
      else if (userRole === "TMM") {
        apiCallsToMake.push(getAllSH3Emails({ userEmailid, userRole, divisionCode, salesGroupCode }));
        apiCallsToMake.push(getAllSH5Emails({ userEmailid, userRole, divisionCode, salesGroupCode }));
      }

      const responses = await Promise.all(apiCallsToMake);

      // ───────────────────────────────────────────────
      // 2️⃣ EXTRACT & MERGE EMAILS FROM RESPONSES
      // ───────────────────────────────────────────────
      let sh3Emails = [];
      let sh5Emails = [];
      let tmmEmails = [];

      if (userRole === "SH5") {
        // SH5: responses[0] = SH3
        sh3Emails = responses[0]?.success
          ? responses[0].data.records.map((item) => item.SH3_Email__c)
          : [];
      } else if (userRole === "SH6") {
        // SH6: responses[0] = SH3, responses[1] = SH5
        sh3Emails = responses[0]?.success
          ? responses[0].data.records.map((item) => item.SH3_Email__c)
          : [];
        sh5Emails = responses[1]?.success
          ? responses[1].data.records.map((item) => item.SH5_Email__c)
          : [];
      } else if (userRole === "SH7") {
        // SH7: responses[0] = SH3, responses[1] = SH5, responses[2] = SH6 (TMM)
        sh3Emails = responses[0]?.success
          ? responses[0].data.records.map((item) => item.SH3_Email__c)
          : [];
        sh5Emails = responses[1]?.success
          ? responses[1].data.records.map((item) => item.SH5_Email__c)
          : [];
        tmmEmails = responses[2]?.success
          ? responses[2].data.records.map((item) => item.SH6_Email__c)
          : [];
      } else if (userRole === "TMM") {
        // TMM: responses[0] = SH3, responses[1] = SH5
        sh3Emails = responses[0]?.success
          ? responses[0].data.records.map((item) => item.SH3_Email__c)
          : [];
        sh5Emails = responses[1]?.success
          ? responses[1].data.records.map((item) => item.SH5_Email__c)
          : [];
      }

      console.log("tmmEmails===>", tmmEmails);

      // Combine + remove empty + dedupe
      const combinedEmails = [...sh3Emails, ...sh5Emails, ...tmmEmails]
        .filter(Boolean)
        .filter((value, index, self) => self.indexOf(value) === index); // dedupe

      // ───────────────────────────────────────────────
      // 3️⃣ IF WE HAVE EMAILS → FORMAT FOR QUERY
      // ───────────────────────────────────────────────
      if (combinedEmails.length > 0) {
        const formattedEmails = combinedEmails
          .map((email) => `'${email}'`)
          .join(",");

        // ───────────────────────────────────────────────
        // 4️⃣ CALL MEETING API WITH MERGED EMAIL LIST
        // ───────────────────────────────────────────────
        const meetingResponse = await getAllSH3EmailsMeetDetails({
          emailList: formattedEmails,
        });

        console.log("Meeting Response==>", meetingResponse);
        if (
          meetingResponse.success &&
          Array.isArray(meetingResponse.data.records)
        ) {
          setMeetingDetails(meetingResponse.data.records);
        } else {
          setMeetingDetails([]);
        }
      } else {
        setMeetingDetails([]);
      }
    } catch (error) {
      console.error("Error fetching SH3/SH5/TMM emails or meetings:", error);
      setMeetingDetails([]);
    } finally {
      setLoading(false);
    }
  }, [divisionCode, salesGroupCode, userEmailid, userRole]);

  useEffect(() => {
    fetchEmailsAndMeetings();
  }, [fetchEmailsAndMeetings]);

  const navigate = useNavigate();

  const handleClick = (item) => {
    console.log("data", item);
    navigate(`/drm-details/${item.Id}`, { state: item });
  };

  const reject = (meetingId) => {
    setSelectedMeetingId(meetingId);
    setIsRejectModalOpen(true);
  };

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
    setRemarksError(false);
  };

  const handleSubmitRemark = () => {
    if (remarks.trim() === "") {
      setRemarksError(true);
      return;
    } else {
      handleAction(selectedMeetingId, "Reject");
      setLoading(true);
      setIsRejectModalOpen(false);
      setRemarks("");
    }
  };

  const handleAction = async (meetingId, action) => {
    let payload = [
      {
        Id: meetingId,
        ZSM_Status: "",
        NSM_Status: "",
        TMM_Status: "",
        ZSM_Feedback: "",
        NSM_Feedback: "",
        TMM_Feedback: "",
      },
    ];

    // Action logic based on userRole and action type
    if (userRole === "SH5" || userRole === "SH6") {
      // ZSM ACTION
      if (action === "Approve") {
        payload[0].ZSM_Status = "Approved";

        // Next stage is TMM if exists, else NSM
        payload[0].TMM_Status = "Pending";
      } else if (action === "Reject") {
        payload[0].ZSM_Status = "Rejected";
        payload[0].ZSM_Feedback = remarks;
      }
    } else if (userRole === "TMM") {
      // TMM ACTION
      if (action === "Approve") {
        payload[0].TMM_Status = "Approved";

        // After TMM → NSM
        payload[0].NSM_Status = "Pending";
      } else if (action === "Reject") {
        payload[0].TMM_Status = "Rejected";
        payload[0].TMM_Feedback = remarks;
      }
    } else if (userRole === "SH7") {
      // NSM ACTION
      if (action === "Approve") {
        payload[0].NSM_Status = "Approved";
      } else if (action === "Reject") {
        payload[0].NSM_Status = "Rejected";
        payload[0].NSM_Feedback = remarks;
      }
    }

    try {
      setLoading(true);
      const response = await addMeetingApprovalApi(payload);
      if (response.success) {
        fetchEmailsAndMeetings();
      } else {
        alert(`Failed to ${action} meeting`);
      }
    } catch (error) {
      console.error("Approval API Error:", error);
      alert("Error processing request");
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // FILTER FUNCTIONS FOR DIFFERENT ROLES AND TABS
  // ═══════════════════════════════════════════════════════════════════════════

  // BM TAB FILTER: Shows records based on user role
  const getBMTabData = () => {
    if (userRole === "SH5" || userRole === "SH6") {
      // ZSM users: Records created by BM, pending ZSM approval
      return meetingDetails.filter((item) => item?.ZSM_Status__c === "Pending" || item?.ZSM_Status__c === null);
    } else if (userRole === "TMM") {
      // TMM users: Records after ZSM approved, pending TMM approval
      return meetingDetails.filter(
        (item) =>
          item?.ZSM_Status__c === "Approved" &&
          item?.TMM_Status__c === "Pending"
      );
    } else if (userRole === "SH7") {
      // NSM users: Records after TMM approved, pending NSM approval
      return meetingDetails.filter(
        (item) =>
          item?.TMM_Status__c === "Approved" &&
          item?.NSM_Status__c === "Pending"
      );
    }
    return [];
  };

  // ZSM TAB FILTER: Shows ZSM created records based on user role
  const getZSMTabData = () => {
    if (userRole === "TMM") {
      // TMM users: ZSM created records, pending TMM approval
      return meetingDetails.filter(
        (item) =>
          item?.isZSMCreated__c === "true" &&
          item?.TMM_Status__c === "Pending"
      );
    } else if (userRole === "SH7") {
      // NSM users: ZSM created records, TMM approved, pending NSM approval
      return meetingDetails.filter(
        (item) =>
          item?.isZSMCreated__c === "true" &&
          item?.TMM_Status__c === "Approved" &&
          item?.NSM_Status__c === "Pending"
      );
    }
    return [];
  };

  // TMM TAB FILTER: Shows TMM created records (for SH7 only)
  const getTMMTabData = () => {
    if (userRole === "SH7") {
      // NSM users: TMM created records, pending NSM approval
      return meetingDetails.filter(
        (item) =>
          item?.isTMMCreated__c === "true" &&
          item?.NSM_Status__c === "Pending"
      );
    }
    return [];
  };

  // Get data based on selected tab
  const getTabData = (selectedTab) => {
    if (selectedTab === "BM") return getBMTabData();
    if (selectedTab === "ZSM") return getZSMTabData();
    if (selectedTab === "TMM") return getTMMTabData();
    return [];
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // REUSABLE MEETING CARD COMPONENT
  // ═══════════════════════════════════════════════════════════════════════════

  const MeetingCard = ({ item }) => {
    const hasDeviation = item?.Deviation_Comments__c && item.Deviation_Comments__c.trim() !== "";
    
    return (
      <div className={`col-md-6 col-lg-4 ${styles.drmMeetingApproval}`}>
        <div 
          className={styles.drmMeetingApproval__mainBox}
          style={{
            border: hasDeviation ? "1px solid #d32f2f" : "",
            boxShadow: hasDeviation 
              ? "0 0 8px rgba(211, 47, 47, 0.3)" 
              : "1.28262px 1.28262px 5.50103px rgba(20, 20, 20, 0.07)"
          }}
        >
          <div className="row m-0 p-0">
            <div className={`col-12 ${styles.drmMeetingApproval__rightBox}`}>
            <div className="row">
              <div className="col-10">
                <h5 className={styles.drmMeetingApproval__title}>
                  Meeting ID - {item?.Id}
                </h5>
              </div>
              <div className="col-2 align-content-center text-center">
                <SlArrowRightCircle
                  className={styles.drmMeetingApproval__redirectArrow}
                  onClick={() => handleClick(item)}
                />
              </div>
            </div>

            {item?.Tentative_date_of_the_meet__c && (
              <p className={styles.drmMeetingApproval__desp}>
                Tentative Date :{" "}
                {_.isEmpty(item?.Tentative_date_of_the_meet__c)
                  ? "----"
                  : item?.Tentative_date_of_the_meet__c}
              </p>
            )}

            <hr className="m-1" />

            <div className={styles.drmMeetingApproval__despRow}>
              <div className={styles.drmMeetingApproval__despBox}>
                <div className={styles.drmMeetingApproval__despBoxName}>
                  Cluster Name :
                </div>
                <div className={styles.drmMeetingApproval__despBoxValue}>
                  {item.Cluster_Name__c}
                </div>
              </div>
            </div>

            {item?.Town_name__c !== "Town A" && item?.Town_name__c && (
              <div className={styles.drmMeetingApproval__despRow}>
                <div className={styles.drmMeetingApproval__despBox}>
                  <div className={styles.drmMeetingApproval__despBoxName}>
                    Town Name :
                  </div>
                  <div className={styles.drmMeetingApproval__despBoxValue}>
                    {item.Town_name__c}
                  </div>
                </div>
              </div>
            )}

            {item?.TSI_Territory_Name__c && (
              <div className={styles.drmMeetingApproval__despRow}>
                <div className={styles.drmMeetingApproval__despBox}>
                  <div className={styles.drmMeetingApproval__despBoxName}>
                    Territory Name :
                  </div>
                  <div className={styles.drmMeetingApproval__despBoxValue}>
                    {item.TSI_Territory_Name__c}
                  </div>
                </div>
              </div>
            )}

            <div className={styles.drmMeetingApproval__despRow}>
              <div className={styles.drmMeetingApproval__despBox}>
                <div className={styles.drmMeetingApproval__despBoxName}>
                  Cost per Head :
                </div>
                <div
                  className={styles.drmMeetingApproval__despBoxValue}
                  style={{
                    color:
                      hasDeviation
                        ? "#d32f2f"
                        : "#2b2b2b",
                    fontWeight:
                      hasDeviation
                        ? "600"
                        : "400",
                    fontSize: hasDeviation ? "0.85rem" : "0.683rem",
                  }}
                >
                  <strong style={{ fontSize: hasDeviation ? "0.9rem" : "inherit" }}>
                    {item.Cost_Per_Head__c}
                  </strong>
                  {hasDeviation && (
                    <span
                      style={{
                        marginLeft: "5px",
                        fontSize: "0.7rem",
                        color: "#d32f2f",
                      }}
                    >
                      ⚠️ Deviation
                    </span>
                  )}
                </div>
              </div>
            </div>

            {hasDeviation && (
              <div className={styles.drmMeetingApproval__despRow}>
                <div className={styles.drmMeetingApproval__despBox}>
                  <div className={styles.drmMeetingApproval__despBoxName}>
                    Deviation Reason :
                  </div>
                  <div
                    className={styles.drmMeetingApproval__despBoxValue}
                    style={{ fontStyle: "italic", color: "#555" }}
                  >
                    {item.Deviation_Comments__c}
                  </div>
                </div>
              </div>
            )}

            {item?.Type_of_DRM__c && (
              <div className={styles.drmMeetingApproval__despRow}>
                <div className={styles.drmMeetingApproval__despBox}>
                  <div className={styles.drmMeetingApproval__despBoxName}>
                    Type of DRM :
                  </div>
                  <div className={styles.drmMeetingApproval__despBoxValue}>
                    {item.Type_of_DRM__c}
                  </div>
                </div>
              </div>
            )}

            {item?.Estimated_no_of_Dealers_to_Participate__c && (
              <div className={styles.drmMeetingApproval__despRow}>
                <div className={styles.drmMeetingApproval__despBox}>
                  <div className={styles.drmMeetingApproval__despBoxName}>
                    Estimated Dealers :
                  </div>
                  <div className={styles.drmMeetingApproval__despBoxValue}>
                    {item.Estimated_no_of_Dealers_to_Participate__c}
                  </div>
                </div>
              </div>
            )}

            {item?.No_of_Dealers_invited__c && (
              <div className={styles.drmMeetingApproval__despRow}>
                <div className={styles.drmMeetingApproval__despBox}>
                  <div className={styles.drmMeetingApproval__despBoxName}>
                    Dealers Invited :
                  </div>
                  <div className={styles.drmMeetingApproval__despBoxValue}>
                    {item.No_of_Dealers_invited__c}
                  </div>
                </div>
              </div>
            )}

            <div className={styles.drmMeetingApproval__despRow}>
              <div className={styles.drmMeetingApproval__buttonBox}>
                <button
                  className={styles.drmMeetingApproval__approveButton}
                  onClick={() => handleAction(item?.Id, "Approve")}
                >
                  Approve
                </button>
                <button
                  className={styles.drmMeetingApproval__rejectButton}
                  onClick={() => reject(item?.Id, "Reject")}
                >
                  Rework
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

  return (
    <>
      <Loader loading={loading} />
      <PageHeader title="DRM Meeting Approval" path="/" />
      <>
        {/* ZSM (SH5/SH6) USERS: Show BM data without tabs */}
        {userRole === "SH5" || userRole === "SH6" ? (
          <div className="row m-0 g-0 d-flex">
            {getBMTabData().length > 0 ? (
              getBMTabData().map((item, index) => (
                <MeetingCard key={index} item={item} />
              ))
            ) : (
              <Message
                message={"No data found"}
                className={"tourPlan__messageConatiner"}
              />
            )}
          </div>
        ) : (
          // TMM and NSM USERS: Show tabs based on role
          <Tabs
            defaultActiveKey={tab}
            id="fill-tab-example"
            className="newFeedback__tabHeader"
            onSelect={(selectedTab) => {
              setTab(selectedTab);
            }}
            fill
          >
            {tabs.map((tabName) => (
              <Tab eventKey={tabName} title={tabName} key={tabName}>
                <div className="row m-0 g-0 d-flex">
                  {getTabData(tabName).length > 0 ? (
                    getTabData(tabName).map((item, index) => (
                      <MeetingCard key={index} item={item} />
                    ))
                  ) : (
                    <Message
                      message={
                        tabName === "BM"
                          ? "No BM approvals pending"
                          : tabName === "ZSM"
                          ? "No ZSM approvals pending"
                          : "No TMM approvals pending"
                      }
                      className={"tourPlan__messageConatiner"}
                    />
                  )}
                </div>
              </Tab>
            ))}
          </Tabs>
        )}

        {isRejectModalOpen && (
          <ModalPopup
            className="ModalPopup_Submitted"
            isModalOpen={isRejectModalOpen}
            ModalMainClass="MyDealerSummaryModal"
            setIsModalOpen={setIsRejectModalOpen}
            data={
              <>
                <div className={`${styles.drmMeetingApproval__rejectTitle}`}>
                  Do you want to rework ?
                </div>
                <div className="col-12 d-grid">
                  <label
                    className={styles.drmMeetingApproval__rejectLabel}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {" "}
                    Remarks{" "}
                  </label>
                  <textarea
                    className={styles.drmMeetingApproval__remarkBox}
                    value={remarks}
                    onChange={handleRemarksChange}
                  ></textarea>
                  {remarksError && (
                    <div className={styles.drmMeetingApproval__remarkError}>
                      Remarks cannot be empty.
                    </div>
                  )}
                </div>
              </>
            }
            backdrop={true}
            fade={false}
            showButton={
              <>
                <Loader loading={loading} />
                <div className={styles.drmMeetingApproval__saveBox}>
                  <button
                    className={styles.drmMeetingApproval__cancel}
                    onClick={() => {
                      setIsRejectModalOpen(false);
                    }}
                  >
                    {" "}
                    cancel{" "}
                  </button>
                  <button
                    className={styles.drmMeetingApproval__submit}
                    onClick={() => {
                      handleSubmitRemark();
                    }}
                  >
                    {" "}
                    Submit{" "}
                  </button>
                </div>
              </>
            }
          />
        )}
      </>
    </>
  );
};

export default DRMMeetingApproval;
